import React, { useEffect, useState } from "react";
import { FiUpload } from "react-icons/fi";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import parse from "html-react-parser";
import {
  fetchLeadershipMessages,
  updateLeadershipMessageById,
  deleteLeadershipMessageById,
} from "../../../redux/actions/aboutUsActions";
import axios from 'axios';

export default function DisplayMessage() {
  const dispatch = useDispatch();
  const { data: leadershipData = [], loading } = useSelector(
    (state) => state.aboutUs.leadershipMessages
  );

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      [{ font: [] }],
      ["bold", "italic", "underline"],
      [{ align: [] }],
      ["clean"],
    ],
  };

  const formats = ["font", "header", "bold", "italic", "underline", "align"];

  const [dropdownIndex, setDropdownIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [messageToDelete, setMessageToDelete] = useState(null);

  const [editMessage, setEditMessage] = useState({
    id: "",
    message_type: "",
    name: "",
    designaion: "",
    message: "",
    file: null, // New file object
    imagePreview: null, // For previewing the new image
    image_url: "", // URL to the current image
  });

  useEffect(() => {
    dispatch(fetchLeadershipMessages());
  }, [dispatch]);

  const toggleDropdown = (index) => {
    setDropdownIndex(dropdownIndex === index ? null : index);
  };

  const handleEdit = (message) => {
    setEditMessage({
      id: message.id,
      message_type: message.message_type || "",
      name: message.name || "",
      designaion: message.designaion || "",
      message: message.message || "",
      image_url: message.image_url || "", // For preview
      image_path: message.image_path || "", // For backend
      file: null, // Reset file input
      imagePreview: null, // Reset image preview
    });
    setIsEditModalOpen(true);
    setDropdownIndex(null);
  };

  const handleDelete = (message) => {
    setMessageToDelete(message);
    setIsDeleteModalOpen(true);
    setDropdownIndex(null);
  };

  const confirmDelete = async () => {
    if (messageToDelete) {
      await dispatch(deleteLeadershipMessageById(messageToDelete.id));
      setIsDeleteModalOpen(false);
      setMessageToDelete(null);
      dispatch(fetchLeadershipMessages());
    }
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setMessageToDelete(null);
  };

  const closeModal = () => {
    setIsEditModalOpen(false);
    setEditMessage(null);
  };

  const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

// Usage in handleUpdate:
const handleUpdate = async (e) => {
  e.preventDefault();

  const formDataToSend = new FormData();
  const { id, message_type, name, designaion, message, file,image_path, image_url } = editMessage;

  if (!message_type || !name || !designaion ) {
    alert("All fields are required!");
    return;
  }

  const plainMessage = stripHtml(message);

      if (!plainMessage.trim()) {
        alert("Message cannot be empty.");
        return;
      }

  formDataToSend.append("message_type", message_type);
  formDataToSend.append("name", name);
  formDataToSend.append("designaion", designaion);
  formDataToSend.append("message", message);
  formDataToSend.append("file", file);

  // if (file) {
  //   formDataToSend.append("file", file); // If user uploads a new file
  // } else if (image_url) {
  //   try {
  //     const generatedFile = await fetchImageAndGenerateFile(image_url,image_path); // Generate a File from the image_url
  //     formDataToSend.append("file", generatedFile); // Add the generated file
  //   } catch (error) {
  //     alert("Error generating file from the image URL.");
  //     return;
  //   }
  // }

  try {
    await dispatch(updateLeadershipMessageById(id, formDataToSend)); // Call the backend
    alert("Leadership message updated successfully!");
    setIsEditModalOpen(false);
    dispatch(fetchLeadershipMessages());
  } catch (error) {
    console.error("Error updating leadership message:", error);
  }
};


  
  
  

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="p-6 bg-white rounded-lg shadow-md">
      <h2 className="mb-4 text-xl font-semibold text-gray-700">
        Added Leadership Messages
      </h2>
      <div className="space-y-4">
        {leadershipData.map((msg, index) => (
          <div
            key={msg.id}
            className="relative flex items-start justify-between p-4 bg-gray-100 rounded-md"
          >
            <div>
              <h3 className="text-lg font-semibold text-gray-700">
                {msg.designaion}'
              </h3>
              <p className="mt-2 mb-2 text-sm font-semibold text-gray-600">
                {msg.name}
              </p>
              <p className="text-gray-500">{parse(msg.message)}</p>
            </div>
            <div className="relative">
              <button
                className="font-bold text-gray-500 hover:text-gray-700"
                onClick={() => toggleDropdown(index)}
              >
                &#8942; {/* Vertical dots */}
              </button>
              {dropdownIndex === index && (
                <div className="absolute right-0 z-10 mt-2 bg-white border border-gray-200 rounded-md shadow-lg">
                  <button
                    className="block w-full px-4 py-2 text-sm text-left text-gray-700 hover:bg-gray-100"
                    onClick={() => handleEdit(msg)}
                  >
                    Edit
                  </button>
                  <button
                    className="block w-full px-4 py-2 text-sm text-left text-gray-700 hover:bg-gray-100"
                    onClick={() => handleDelete(msg)}
                  >
                    Delete
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Edit Modal */}
      {isEditModalOpen && (
        <div className="fixed top-0 left-0 z-50 flex items-center justify-center w-full h-full bg-black bg-opacity-50">
          <div className="w-[1100px] h-[600px] p-8 bg-white rounded-lg shadow-lg overflow-y-auto">
            <h2 className="mb-6 text-2xl font-semibold text-gray-700">
              Edit Leadership Messages
            </h2>
            <form onSubmit={handleUpdate}>
              <div className="grid grid-cols-3 gap-6 mb-6">
                <div>
                  <label className="block mb-1 text-sm font-medium text-gray-600">
                    Position
                  </label>
                  <select
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                    value={editMessage.message_type || ""}
                    onChange={(e) =>
                      setEditMessage({
                        ...editMessage,
                        message_type: e.target.value,
                      })
                    }
                  >
                    <option value="" disabled>
                      Select Position
                    </option>
                    <option value="President">President</option>
                    <option value="Vice President">Vice President</option>
                    <option value="CEO">CEO</option>
                    <option value="Director">Director</option>
                  </select>
                </div>
                <div>
                  <label className="block mb-1 text-sm font-medium text-gray-600">
                    Name
                  </label>
                  <input
                    type="text"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                    value={editMessage.name || ""}
                    onChange={(e) =>
                      setEditMessage({ ...editMessage, name: e.target.value })
                    }
                  />
                </div>
                <div>
                  <label className="block mb-1 text-sm font-medium text-gray-600">
                    Designation
                  </label>
                  <input
                    type="text"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                    value={editMessage.designaion || ""}
                    onChange={(e) =>
                      setEditMessage({
                        ...editMessage,
                        designaion: e.target.value,
                      })
                    }
                  />
                </div>
              </div>

              <div className="grid grid-cols-3 gap-6 mb-6">
           
<div className="flex flex-col items-center justify-center w-full h-[225px] p-5 border border-gray-300 border-dashed rounded-md relative">
  <input
    id="fileInput"
    type="file"
    name="file"
    accept=".jpg, .png,.webp"
    className="absolute inset-0 opacity-0 cursor-pointer"
    onChange={(e) => {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setEditMessage({ ...editMessage, file, imagePreview: reader.result });
        };
        reader.readAsDataURL(file);
      }
    }}
  />
  {(editMessage.imagePreview || editMessage.image_url) ? (
    <div className="relative w-full h-full">
      <img
        src={editMessage.imagePreview || editMessage.image_url}
        alt="Preview"
        className="object-contain w-full h-full rounded-md opacity-80"
      />
      <div className="absolute top-0 left-0 flex items-center justify-center w-full h-full gap-2">
        <button
          type="button"
          className="px-4 py-2 bg-white border rounded-md text-primary-color border-primary-color"
          onClick={() => document.getElementById('fileInput').click()} // Trigger input click
        >
          Browse Image
        </button>
      </div>
    </div>
  ) : (
    <>
      <FiUpload className="w-10 h-10 p-2 mb-3 text-gray-400 bg-gray-100 border-none rounded-md" />
      <p className="text-black">Drag and drop image here</p>
      <p className="text-gray-400">or</p>
      <button
        type="button"
        className="px-4 py-2 mt-2 text-[#92288C] font-semibold bg-[#92288C] bg-opacity-10 rounded-md"
        onClick={() => document.getElementById('fileInput').click()} // Trigger input click
      >
        Browse Image
      </button>
    </>
  )}
</div>



                <div className="col-span-2">
                  <label className="block mb-1 text-sm font-medium text-gray-600">
                    Message
                  </label>
                  <ReactQuill
                    id="message"
                    value={editMessage.message || ""}
                    onChange={(value) =>
                      setEditMessage({ ...editMessage, message: value })
                    }
                    theme="snow"
                    modules={modules}
                    formats={formats}
                    className="h-[180px]"
                  />
                </div>
              </div>

              <div className="flex justify-end gap-4">
                <button
                  type="button"
                  className="px-6 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
                  onClick={closeModal}
                >
                  Back
                </button>
                <button
                  type="submit"
                  className="px-6 py-2 text-white bg-[#92288C] rounded-md hover:bg-[#6C0B67]"
                >
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {isDeleteModalOpen && (
        <div className="fixed top-0 left-0 z-50 flex items-center justify-center w-full h-full bg-black bg-opacity-50">
          <div className="w-[400px] p-8 bg-white rounded-lg shadow-lg text-center">
            <h3 className="mb-4 text-xl font-semibold text-gray-700">
              Delete?
            </h3>
            <p className="mb-6 text-gray-600">
              Are you sure you want to delete this message? <br />
              <strong>{messageToDelete?.designaion}'s Message</strong>
            </p>
            <div className="flex justify-center gap-4">
              <button
                className="px-6 py-2 text-gray-500 bg-gray-200 rounded-md hover:bg-gray-300"
                onClick={closeDeleteModal}
              >
                No
              </button>
              <button
                className="px-6 py-2 text-white bg-[#92288C] rounded-md"
                onClick={confirmDelete}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
